import React, { FC } from 'react';
import Helmet from 'react-helmet';
import { PRIMARY_COLOR } from './headConstants';

export const HeadBrowserConfig: FC = () => (
  <Helmet>
    {/* Internet Explorer compatibility */}
    <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
    {/* Chrome, Firefox OS and Opera */}
    <meta name="theme-color" content={PRIMARY_COLOR} />
    {/* Windows Phone */}
    <meta name="msapplication-navbutton-color" content={PRIMARY_COLOR} />
    {/* iOS Safari */}
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <meta
      name="apple-mobile-web-app-status-bar-style"
      content="black-translucent"
    />
    <meta name="viewport" content="width=device-width, height=device-height" />
  </Helmet>
);
